export class PricingProduct {
	id: number;
	name: string;
	displayName: string;
	hyperlineName: string;
	startDate: Date | string;
	endDate?: Date | string | null;
	createdDate: Date | string;
	updatedDate?: Date | string | null;
}
